window.AddMembersConfirmation = (function() {
    window.dataLayer = window.dataLayer || [];

    let self = {
        urls: {
            redirectUrl: '/my-health-insurance/manage-my-plan',
            errorPageUrl: '/error/error-page',
            resetSession: '/api/sitecore/AddMembers/ResetSession',
        },
        func: {
            init: function() {
                self.func.bindings();
            },
            bindings: function() {
                $('#add-members-confirm-button').on('click', self.func.removeSessionAndRedirect);
            },
            removeSessionAndRedirect: function() {
                $.post(self.urls.resetSession)
                    .done(function() {
                        window.location.href = self.urls.redirectUrl;
                    });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function() {
    if ('add-members-confirm-section' === $('#add-members-confirm-section').data('feature')) {
        window.AddMembersConfirmation.Init();
    }
});
